export default Object.freeze({
  SERVERCTRL: "//bdbeta.brandiie.com/controller.php",
  LOGINCHECK: "//bdbeta.brandiie.com/secure.php"

  // SERVERCTRL: "//bds.test/controller.php",
  //LOGINCHECK: "//bds.test/secure.php" //,

  //CONTROLLER: "//bds.test/api/p.json",
  //CONTROLLER: "/p.json",
  //CLIENTS: "//bds.test/api/c.json",
  //CLIENTS: "/c.json",
  //CONTRACTS: "//bds.test/api/ct.json"
  //CONTRACTS: "/ct.json"
});
